import { render, staticRenderFns } from "./starrating.vue?vue&type=template&id=d908ffdc&"
import script from "./starrating.vue?vue&type=script&lang=js&"
export * from "./starrating.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d908ffdc')) {
      api.createRecord('d908ffdc', component.options)
    } else {
      api.reload('d908ffdc', component.options)
    }
    module.hot.accept("./starrating.vue?vue&type=template&id=d908ffdc&", function () {
      api.rerender('d908ffdc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2drp50WKJzEMO/JS/starrating.vue"
export default component.exports